import React from 'react';

import styles from './styles.module.scss';
import {Hero} from './Hero';
import {Cards} from './Cards';
import {Main} from './Main';

export const Features = () => {
  return (
    <div className={styles.home}>
      <Hero />
      <Cards />
      <Main />
    </div>
  );
};
